module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false,
      "before-close": _vm.close
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', [(_vm.OrderData.OrderFrom == 1) ? _c('div', [_c('el-row', [_c('h4', [_vm._v("下单宝贝信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员ID："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyInfo.Id))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员姓名："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyInfo.BabyName))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AgentInfo.AgentName !== undefined),
      expression: "AgentInfo.AgentName!==undefined"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属代理商："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.AgentInfo.AgentName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.AgentInfo.C_Name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属园所："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属班级："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassName))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("下单家长信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单家长："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ParentInfo.UserName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单家长电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ParentInfo.UserTel))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "与宝贝的家庭关系："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ParentInfo.ParentNick))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("家庭网络情况")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运营商："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.NetworkOperatorName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家庭网络情况："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.NetworkTypeName))])])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.NetInfo.DistanceName !== ''),
      expression: "NetInfo.DistanceName!==''"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电视到宽带口距离多远："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.DistanceName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否需要IT工程师上门服务："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.EngineerName))])])], 1)], 1)], 1) : _c('div', [_c('el-row', [_c('h4', [_vm._v("园所信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.PrincipalName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.PhoneNo))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所地址："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolAddress))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("班级信息\n                        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ClassInfo.ClassId == 0),
      expression: "ClassInfo.ClassId==0"
    }]
  }, [_vm._v("（未配置班级）")]), _vm._v(" "), (_vm.ClassInfo.ClassId == 0) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow),
      expression: "isFollow"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeClass
    }
  }, [_vm._v("配置班级")]) : _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow),
      expression: "isFollow"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.changeClass
    }
  }, [_vm._v("更换检测班级")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ClassInfo.ClassId != ''),
      expression: "ClassInfo.ClassId!=''"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级年段："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.GradeName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级昵称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassNick))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备绑定码："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassId))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班主任姓名："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.TeacherInfo.UserName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班主任电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.TeacherInfo.PhoneNo))])])], 1)], 1)]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.NetInfo.NetworkOperatorName !== undefined),
      expression: "NetInfo.NetworkOperatorName!==undefined"
    }]
  }, [_c('h4', [_vm._v("园所网络情况")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所网络运营商："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.NetworkOperatorName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所班级是否有网络："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.IsSpecilLine))])])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.NetInfo.DistanceName !== ''),
      expression: "NetInfo.DistanceName!==''"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "网络到一体机电视距离："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.DistanceName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否需要IT工程师上门服务："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.NetInfo.EngineerName))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("下单人信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务员："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SalesInfo.C_Name))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "业务员电话："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SalesInfo.C_Tel))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("发货信息")]), _vm._v(" "), _c('p', [_vm._v("发货情况：" + _vm._s(_vm.OrderData.SendStatusName) + "\n                    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.StockOutNum == 0),
      expression: "OrderData.StockOutNum==0"
    }]
  }, [_vm._v("（该订单不涉及设备发货）")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.StockOutNum !== 0 && _vm.OrderData.AgentOutNum !== 0),
      expression: "OrderData.StockOutNum!==0&&OrderData.AgentOutNum!==0"
    }]
  }, [_vm._v("（其中" + _vm._s(_vm.OrderData.StockOutNum) + "台公司发货，" + _vm._s(_vm.OrderData.AgentOutNum) + "台代理商库存出库）")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OrderData.StockOutNum !== 0 && _vm.OrderData.AgentOutNum == 0),
      expression: "OrderData.StockOutNum!==0&&OrderData.AgentOutNum==0"
    }]
  }, [_vm._v("（其中" + _vm._s(_vm.OrderData.StockOutNum) + "台公司发货）")])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.ReceiveInfo,
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "物料",
      "prop": "ProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "快递",
      "prop": "LogisticsName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "快递单号",
      "prop": "LogisticsCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货时间",
      "prop": "StockOutTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("网络检测跟进情况\n                    "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFollow && _vm.OrderData.CheckStatus !== 10),
      expression: "isFollow&&OrderData.CheckStatus!==10"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.followFn
    }
  }, [_vm._v("新增跟进")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FollowInfo,
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "跟进人",
      "prop": "FollowEmployeeName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "跟进时间",
      "prop": "FolllowTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检测进度",
      "prop": "FollowScheduleName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检测结果",
      "prop": "FollowStatusName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "Remark"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IMEI",
      "prop": "IMEI"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1), _vm._v(" "), _c('classList', {
    ref: "refsClass",
    on: {
      "reloadList": function($event) {
        _vm.GetById(_vm.Id)
      }
    }
  }), _vm._v(" "), _c('follow', {
    ref: "refsFollow",
    on: {
      "reloadList": function($event) {
        _vm.GetById(_vm.Id)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11b88202!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Network/networkCheck/components/networkModalDialog/index.vue
// module id = 1386
// module chunks = 1